import type { Dispatch, AnyAction } from 'redux';

import * as CreateDirectoryAPI from 'ab-api/web/job/createDirectory';
import * as DeleteDirectoryAPI from 'ab-api/web/job/deleteDirectory';
import * as FindJobAttachmentsAPI from 'ab-api/web/job/findJobAttachments';

import type { GetRootState } from 'af-reducers';

import { errorHandler } from 'af-utils/actions.util';
import { http } from 'af-utils/http.util';

// Attachments:
export function getWorkRequestDirectoriesAttachments(jobId: number) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {

			const directoriesWithAttachments = await http.get<FindJobAttachmentsAPI.W_Job_FindJobAttachments_VM>(
				FindJobAttachmentsAPI.URL(jobId)
			);
			return directoriesWithAttachments.directories;
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function createDirectory(jobId: number, parentDirectoryId: number, newDirName: string) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			const requestBody: CreateDirectoryAPI.W_Job_CreateDirectory_RM = { name: newDirName };
			await http.post<void>(CreateDirectoryAPI.URL(jobId, parentDirectoryId), requestBody);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function deleteDirectory(jobId: number, directoryId: number) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			await http.delete<void>(DeleteDirectoryAPI.URL(jobId, directoryId));
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}
